var _defs, _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _g2, _rect9, _rect10, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerConsultancy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76.8 76.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-0.01 -0.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 76.99,
    height: 77.18
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.11,48.83a2.58,2.58,0,0,0-2.58,2.58v3.82h2.56l0-3.84H51.2V48.83Z",
    transform: "translate(-0.01 -0.18)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.76,
    y: 48.65,
    width: 2.56,
    height: 2.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.53,43.71H58.89V38.59a1.29,1.29,0,0,0-1.29-1.28H39.69V30.16l4.74-4.74a1.29,1.29,0,0,0,.37-.91V20.67H42.24V24l-2.55,2.56V18.11H37.12v11l-2.56-2.56V22H32v5.12a1.3,1.3,0,0,0,.38.91l4.74,4.74v4.59H17.92a1.29,1.29,0,0,0-1.28,1.28v5.12H3.84A1.29,1.29,0,0,0,2.56,45V60.25L0,75.5A1.28,1.28,0,0,0,1.08,77a.68.68,0,0,0,.21,0H34.56a1.28,1.28,0,0,0,1.28-1.28,1.48,1.48,0,0,0,0-.21L33.29,60.25V45A1.29,1.29,0,0,0,32,43.71H19.2V39.87H56.33v3.84H39.69A1.29,1.29,0,0,0,38.4,45V69.31a1.28,1.28,0,0,0,1.29,1.28H52.2l-.76,3.84h-2.8V77H66.56V74.43H63.77L63,70.59H75.53a1.27,1.27,0,0,0,1.27-1.28V45a1.28,1.28,0,0,0-1.27-1.28ZM33.05,74.43H2.8l2.13-12.8h26ZM30.72,46.27v12.8H5.12V46.27ZM54.05,74.43l.76-3.84H60.4l.76,3.84ZM74.24,68H41V65.47H74.24Zm0-5.12H41V46.27H74.24Z",
    transform: "translate(-0.01 -0.18)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.4,
    y: 64.01,
    width: 2.56,
    height: 2.56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.4,
    y: 69.13,
    width: 2.56,
    height: 2.56
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.52,
    y: 69.13,
    width: 12.8,
    height: 2.56
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.88,
    y: 69.13,
    width: 2.56,
    height: 2.56
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.52,
    y: 64.01,
    width: 2.56,
    height: 2.56
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.64,
    y: 64.01,
    width: 2.56,
    height: 2.56
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.76,
    y: 64.01,
    width: 2.56,
    height: 2.56
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26.88,
    y: 64.01,
    width: 2.56,
    height: 2.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.27,48.83a2.58,2.58,0,0,0-2.58,2.58v3.82h2.55l0-3.84h5.09V48.83Z",
    transform: "translate(-0.01 -0.18)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.92,
    y: 48.65,
    width: 2.56,
    height: 2.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2,6.59a14.15,14.15,0,0,0-3.54.46A11.52,11.52,0,0,0,25.6,11.71V12a11.52,11.52,0,1,0-5.11,22.46,10.9,10.9,0,0,0,2.55.29H33.28V32.19H23a9,9,0,0,1,0-17.92A8.87,8.87,0,0,1,26.6,15a1.28,1.28,0,0,0,1.76-1.44,9.63,9.63,0,0,1-.2-1.86A9,9,0,0,1,45.67,9a1.28,1.28,0,0,0,1.61.84l0,0A11.52,11.52,0,1,1,51.2,32.19H43.53v2.56H51.2a14.08,14.08,0,0,0,0-28.16Z",
    transform: "translate(-0.01 -0.18)"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 37.12,
    y: 12.81,
    width: 2.56,
    height: 2.56
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 16.65,
    width: 2.56,
    height: 2.56
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 42.24,
    y: 15.37,
    width: 2.56,
    height: 2.56
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerConsultancy);
export default __webpack_public_path__ + "static/media/banner_consultancy.f8856157cfd82ba8bc472d2142b40883.svg";
export { ForwardRef as ReactComponent };